import { FormContext } from "vee-validate"

// Interface qui représente le résultat de validation v3
export class ValidationResult {
  valid: boolean
  errors: Record<string, string[]>

  constructor(valid: boolean, errors: Record<string, string[]>) {
    this.valid = valid
    this.errors = errors
  }
}

export class VeeValidateAdapter {
  /**
   * Adapte la fonction validateWithInfo de vee-validate v3 vers vee-validate v4
   * Utilisé principalement dans ProjectValidationAndSaveHandler.vue
   *
   * @param formRef - Référence vers le composant Form de vee-validate v4
   * @returns ValidationResult - Format compatible avec vee-validate v3
   */
  static async validateWithInfo(formRef: FormContext): Promise<ValidationResult> {
    try {
      // Utilise l'API v4 pour valider le formulaire
      const { valid, errors } = await formRef.validate()

      // Transforme les erreurs au format v3 (Record<string, string[]>)
      const formattedErrors: Record<string, string[]> = {}

      // Convertit les erreurs de l'API v4 vers le format v3
      Object.entries(errors).forEach(([field, message]) => {
        // S'assurer que message est toujours un tableau de strings
        const errorMessages: string[] = Array.isArray(message)
          ? message.filter((msg): msg is string => typeof msg === "string")
          : message
            ? [message.toString()]
            : []

        formattedErrors[field] = errorMessages
      })

      return new ValidationResult(valid, formattedErrors)
    } catch (error) {
      console.error("Error in validateWithInfo adapter:", error)
      return new ValidationResult(false, {})
    }
  }
}
